export const LINK_BUTTON_CLASS =
    'text-[12px] font-semibold text-gray-600 underline-offset-2 hover:text-gray-900 hover:underline rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400';
export const SECTION_HEADING_CLASS =
    'text-[11px] font-semibold uppercase tracking-wide text-gray-500';
export const DATE_INPUT_CLASS =
    'h-8 w-full min-w-0 rounded-md border border-gray-200 bg-white px-2.5 text-[13px] text-gray-900 focus:outline-none focus:border-gray-400 focus-visible:ring-2 focus-visible:ring-gray-200';
export const CARD_CLASS = 'rounded-xl border border-gray-200 bg-white';

export const TABLE_CELL_PADDING = 'px-3 first:pl-5 last:pr-5';
export const TABLE_HEADER_CLASS = '!px-3 first:!pl-5 last:!pr-5 !text-gray-500';
export const TABLE_ROW_HEIGHT = 'h-[52px]';
// Lets the browse body find the selected row to scroll to and refocus; it carries no styles.
export const SELECTED_ROW_MARKER = 'itero-selected-row';
export const SELECTED_ROW_CLASS = `!bg-gray-100 ${SELECTED_ROW_MARKER}`;
// DataTable renders its footer as the card's last child; letting that row wrap keeps the mode
// toggle in view when the details pane narrows the table.
export const BROWSE_TABLE_CARD_CLASS =
    '!rounded-none !border-0 !shadow-none [&>:last-child>*]:flex-wrap';

export const DEBOUNCE_MS = 350;
export const DETAILS_PANE_WIDTH_CLASS = 'w-[470px]';

const ACTION_BASE =
    'inline-flex shrink-0 items-center gap-1.5 rounded-lg font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-gray-400 disabled:cursor-not-allowed disabled:opacity-50';
const ACTION_SIZE = { md: 'h-8 px-3 text-[13px]', sm: 'h-7 px-2.5 text-[12px]' } as const;
const ACTION_TONE = {
    primary: 'bg-gray-900 text-white hover:bg-gray-800',
    secondary:
        'border border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'
} as const;

export type ActionSize = keyof typeof ACTION_SIZE;
export type ActionTone = keyof typeof ACTION_TONE;

export function actionButtonClass(tone: ActionTone, size: ActionSize = 'md'): string {
    return `${ACTION_BASE} ${ACTION_SIZE[size]} ${ACTION_TONE[tone]}`;
}
